import React, { useEffect } from "react";
import Image from "next/image";
import "./SnackBar.styles.scss";

const SnackBar = ({ containerProps, containerMethods }) => {
  const { message, type } = containerProps;
  const { onClose } = containerMethods;
  const hideSnackbarIcons = true;

  const getIconUrl = () => {
    if (type === "warning") {
      return "/warning-message-icon.webp";
    } else if (type === "error") {
      return "/error-message-icon.png";
    }
    return "/tick-mark-circle-icon.webp";
  };
  return (
    <div className={`snackbar-container ${type}`}>
      <div className="snackbar-content">
        {!hideSnackbarIcons && <div className="snackbar-icon">
          <Image
            className="image"
            src={getIconUrl()}
            alt="tick"
            width={24}
            height={24}
          />
        </div>}
        <div className="snackbar-message">{message}</div>
        <div className="snackbar-close" onClick={onClose}></div>
      </div>
    </div>
  );
};

export default SnackBar;
